function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { DetailContainer } from "../../components/container-activity";
import { BaseDataViewComponentAsync } from "../../components/base";
import publishSearch from '../../functions/publish-search';
import publishEvent from "../../functions/publish-event";
import ServiceFactory from '../../service';
import { Loader } from '../../components/loaders';
import Error from '../../components/error';
import markupParser from "../../functions/markup-parser";
import rangeLabel from "../../functions/range-label";
class MainComponent extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onGoBack", () => {
      this.props.history.goBack();
    });
    _defineProperty(this, "onExportClick", event => {
      let data = this.props.data;
      let content = markupParser(data.text);
      let company = data.company;
      let fileName = company.replace(/ /g, '_');
      fileName += '_analysis.doc';
      const header = `
    <html xmlns:o='urn:schemas-microsoft-com:office:office'
          xmlns:w='urn:schemas-microsoft-com:office:word'
          xmlns='http://www.w3.org/TR/REC-html40'>
    <head><meta charset='utf-8'><title>${company} Analysis</title></head><body>`;
      const footer = '</body></html>';
      const fullHTML = header + content + footer;

      // Create a Blob with the correct MIME type
      const blob = new Blob(['\ufeff', fullHTML], {
        type: 'application/msword'
      });

      // Create a temporary download link
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
    // Insights are generated on demand (2026-09-12): the nightly chain no
    // longer writes them. POST /v1/sales/insights/{type}/{range}/generate serves a
    // fresh (<24h) summary from cache, or asks the model and records the cost.
    _defineProperty(this, "refresh", async force => {
      this.setState({
        refreshing: true,
        refreshError: null
      });
      try {
        var Service = ServiceFactory.getType(`/sales/insights/product-sales-transaction-stats-analysis/this_year/generate${force ? "?force=true" : ""}`, 'product');
        var service = new Service();
        var data = await service.postAsync({});
        this.setState({
          refreshing: false,
          fresh: data
        });
      } catch (err) {
        this.setState({
          refreshing: false,
          refreshError: err && err.message || "Couldn't refresh the analysis."
        });
      }
    });
    this.state = {
      refreshing: false,
      refreshError: null,
      fresh: null
    };
  }
  componentDidMount() {
    publishSearch('Research');
    publishEvent('reset-search', {});
  }
  render() {
    let props = this.props;
    let title = 'Sales Analysis: YTD';
    const st = this.state || {};
    const source = st.fresh && st.fresh.analysis ? st.fresh : props.data;
    let content = markupParser(source.analysis || "");
    const when = source.createdDate ? new Date(source.createdDate) : null;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DetailContainer, {
      title: title,
      onGoBack: this.onGoBack
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        flexWrap: "wrap",
        marginBottom: 12
      }
    }, /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
      disabled: !!st.refreshing,
      onClick: () => this.refresh(true)
    }, st.refreshing ? "Generating…" : source.analysis ? "Refresh insights" : "Generate insights"), /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, when ? `Generated ${when.toLocaleString()}` : "Not generated yet", " \xB7 summaries are produced on request and kept for 24 hours."), st.refreshError && /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: 12.5,
        color: "var(--plk-accent, #ff6358)"
      }
    }, st.refreshError)), !source.analysis && /*#__PURE__*/React.createElement("p", {
      className: "territory-hint"
    }, "No analysis yet \u2014 click Generate insights."), /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: content
      }
    }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null)));
  }
}
export class SalesAnalysisViewComponent extends BaseDataViewComponentAsync {
  constructor(props) {
    super(props);
  }
  async fetchData() {
    var Service = ServiceFactory.getType('/sales/analysis/this_year', 'product');
    var service = new Service();
    try {
      var data = await service.getAsync();
      console.log(data);
      this.allowRender = true;
      this.data = data;
      this.allowRender = true;
      this.allowUpdate = false;
      this.forceUpdate();
      window.scrollTo(0, 0);
    } catch (err) {
      this.error = true;
      this.errorMessage = err.message;
      this.allowRender = true;
      this.allowUpdate = false;
      this.forceUpdate();
    }
  }
  render() {
    if (!this.allowRender) {
      return /*#__PURE__*/React.createElement(Loader, null);
    } else if (this.error) {
      return /*#__PURE__*/React.createElement(Error, {
        message: this.errorMessage
      });
    } else {
      return /*#__PURE__*/React.createElement(RoutableComponent, {
        data: this.data,
        params: this.props.params
      });
    }
  }
}
const RoutableComponent = withRouter(MainComponent);
export default {
  SalesAnalysisViewComponent
};